// extracted by mini-css-extract-plugin
module.exports = {"shareLink":"_621d621"};